module.exports = __webpack_public_path__ + "img/image57.e55f0f72.png";